// extracted by mini-css-extract-plugin
export default {"component":"VersionBanner_component__I2wt+","container":"VersionBanner_container__4r0-X","text":"VersionBanner_text__ZsLBX","button":"VersionBanner_button__OfsYw"};